<template>

  <article class="c-article__highlight c-highlight">
    <div class="o-layout o-layout--middle o-layout--stretch">
      <div class="o-layout__item u-4/10@tablet">
        <div class="c-highlight__img">
          <Shape :img="content.largeImage" :imgOverlay="false" :bg="true" :id="Math.random().toString(36).substring(7)" :color="content.color" />
        </div>
      </div>
      <div class="o-layout__item u-6/10@tablet">
        <div class="c-highlight__content">
          <div class="c-highlight__title">
            <div>
              <h3>{{ content.title }}</h3>
              <Button v-if="content.button" :content="content.button" />
            </div>
          </div>
          <div class="c-highlight__product">
            <img :src="content.productImage.url" :alt="content.title">
          </div>
        </div>
      </div>
    </div>
  </article>

</template>

<script>
import Shape from '@/components/Shape'
import Button from '@/components/Button'

export default {
  name: 'Highlight',
  props: ['content'],

  components: {
    Shape,
    Button
  }
}
</script>
